interface IUrlQueryParams {
    pt: string | null; // Invite a colleague identifier (should be 'iac')
    uid: string | null; // MD5 Hash of Inviters EWA ID
    t: string | null; // Timestamp in UNIX (13 digits)
    ch: string | null; // Channel
}

export const getUrlQueryParams = (url: string): IUrlQueryParams => {
    const urlObj = new URL(url);
    const params = new URLSearchParams(urlObj.search);

    return {
        pt: params.get('pt'),
        uid: params.get('uid'),
        t: params.get('t'),
        ch: params.get('ch'),
    };
};
